var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.title,"centered":"","cancel-variant":"white","ok-variant":"danger","ok-title":"Delete"},on:{"ok":_vm.onConfirm}},[_c('div',{staticClass:"alert alert-danger m-b-0"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }